import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "Dove si trova il Ristorante Da Armando?",
    answer:
      "Il Ristorante Da Armando si trova in Via Aganoor Pompili 25, a Passignano sul Trasimeno (PG), nel cuore del centro storico e con vista panoramica sul Lago Trasimeno. Siamo facilmente raggiungibili in auto dall'uscita autostradale Passignano e a pochi minuti dalla stazione ferroviaria.",
  },
  {
    question: "Quali sono gli orari di apertura?",
    answer:
      "In estate siamo aperti 7 giorni su 7 a pranzo (12:00–15:00) e cena (19:00–23:00), con il giovedì pomeriggio dedicato. In inverno apriamo 6 giorni su 7 con la stessa fascia oraria, chiusi il giovedì. Ti consigliamo sempre di chiamare per conferma stagionale.",
  },
  {
    question: "Come posso prenotare un tavolo?",
    answer:
      "Puoi prenotare un tavolo direttamente dal modulo online sul nostro sito, oppure telefonando al +39 075 388 0397. Consigliamo la prenotazione soprattutto nei weekend, in estate e per i tavoli sulla terrazza panoramica con vista lago.",
  },
  {
    question: "Quali sono le specialità della cucina?",
    answer:
      "La nostra cucina è fortemente legata al territorio umbro. Le specialità principali sono il pesce del Lago Trasimeno (regina in porchetta, persico, tegamaccio), il tartufo nero pregiato, la pasta fatta in casa e le carni alla griglia. Tutti gli ingredienti sono selezionati da produttori locali.",
  },
  {
    question: "Avete una terrazza con vista sul Lago Trasimeno?",
    answer:
      "Sì, disponiamo di una terrazza panoramica di 200 m² con vista diretta sul Lago Trasimeno. È la cornice ideale per pranzi e cene estive. Per garantirti un tavolo in terrazza ti consigliamo di specificarlo al momento della prenotazione.",
  },
  {
    question: "C'è il parcheggio nelle vicinanze?",
    answer:
      "Sì, a pochi passi dal ristorante sono disponibili diverse aree di parcheggio pubbliche, sia gratuite che a pagamento. Nel periodo estivo consigliamo di arrivare con qualche minuto di anticipo per trovare comodamente posto.",
  },
  {
    question: "Il ristorante è adatto per eventi e gruppi?",
    answer:
      "Sì, organizziamo cene di gruppo, ricorrenze, eventi aziendali e cerimonie. Possiamo proporre menù personalizzati e dedicare spazi specifici del locale. Contattaci con anticipo per concordare i dettagli.",
  },
  {
    question: "Accettate pagamenti con carta di credito?",
    answer:
      "Sì, accettiamo contanti, carte di credito e carte di debito (Visa, Mastercard, bancomat). La valuta accettata è l'Euro.",
  },
];

const FAQSection = () => {
  return (
    <section id="faq" className="section-padding bg-background">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-section-title text-primary mb-4">
            Domande <span className="text-gold">Frequenti</span>
          </h2>
          <p className="text-body-large text-muted-foreground max-w-3xl mx-auto font-serif">
            Tutto quello che devi sapere sul nostro ristorante a Passignano sul Trasimeno
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-b border-border"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-primary hover:text-gold py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base text-muted-foreground font-serif leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
